import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../../lib/brand";

export const Ticker = () => (
  <section
    data-testid="ticker-section"
    className="relative border-y border-white/5 bg-[#050505] py-6"
  >
    <Marquee speed={38} gradient gradientColor="#050505" gradientWidth={120}>
      {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl text-zinc-300 px-8">
            {item}
          </span>
          <span className="text-teal-400 text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default Ticker;
